module.exports = __webpack_public_path__ + "static/img/7.3bb95da.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/VascularSystem/Meeting674/images/7.png
// module id = 6xL6
// module chunks = 4